export default __webpack_public_path__ + "static/media/3 - Cabbages.866747f0.jpeg";